/**
 * Bunny Shield API
 * Bunny.net API for Bunny Shield (WAF, DDoS, Rate Limiting, Bot Detection, Access Lists & API Guardian).

 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 0 = Log 1 = Block
 */
export type DDoSExecutionMode = 0 | 1;

export const DDoSExecutionMode = {
  Log: 0 as DDoSExecutionMode,
  Block: 1 as DDoSExecutionMode,
};
